import type { FooterColumnInterface, FooterColumnMenuItemInterface } from '~/interfaces/Footer';
import type { MobileNavItem, NewsLevelInterface } from '~/interfaces';
import type { IHeaderBottomNav } from '~/interfaces/v2/IHeaderBottomNav';
import { AGREEMENT_RSHB_PD_POLICY, AGREEMENT_TERMS } from '~/const/Agreements/AgreementsConst';

export const MENU_MAIN_DESKTOP_BOTTOM: Array<IHeaderBottomNav> = [
  {
    id: 1,
    name: 'Журнал',
    icon: 'book',
    link: '/news',
  },
  {
    id: 2,
    name: 'Личное подсобное хозяйство',
    icon: 'leaves',
    link: '/lph',
  },
  {
    id: 5,
    name: 'Садоводство с нуля',
    icon: 'leaf',
    link: '/sadovodstvo-s-nulya',
  },
];

export const MENU_MAIN_MOBILE: MobileNavItem[] = [
  {
    name: 'Личное подсобное хозяйство',
    url: '/lph',
    icon: '',
  },
  {
    name: 'Садоводство с нуля',
    url: '/sadovodstvo-s-nulya',
    icon: '',
  },
];

export const MENU_MAIN_MOBILE_SUBMENU: MobileNavItem[] = [
  {
    name: 'Другие сервисы',
    url: '#',
    icon: 'ecosystem',
    action: 'toggle-ecosystem-menu',
  },
];

export const MENU_MAIN_MOBILE_HIGHLIGHT_MENU: MobileNavItem[] = [
  // {
  //   name: 'Льготный кредит',
  //   url: '/credits/of_villagers',
  //   icon: 'money-paper'
  // }
];

export const MENU_FOOTER_MOBILE: Array<FooterColumnInterface> = [
  {
    id: 'column2',
    menus: [
      {
        id: 'menu2',
        name: 'Сервисы',
        items: [
          {
            name: 'Журнал',
            url: '/news',
          },
          {
            name: 'Садоводство с нуля',
            url: '/sadovodstvo-s-nulya',
          },
          {
            name: 'Дизайн участка',
            url: '/plans',
          },
          {
            name: 'Календарь садовода',
            url: '/calendar/seasons',
          },
          {
            name: 'Газификация',
            url: '/gas',
          },
          {
            name: 'Личное подсобное хозяйство',
            url: '/lph',
          },
          {
            name: 'Карта Дачная',
            url: '/dachnaya',
          },
        ],
      },
    ],
  },
  {
    id: 'column4',
    menus: [
      {
        id: 'menu4',
        name: 'О нас',
        items: [
          {
            name: 'О Россельхозбанке',
            url: 'https://www.rshb.ru/about/',
            external: true,
          },
        ],
      },
      {
        id: 'menu5',
        name: 'По всем вопросам',
        items: [
          {
            name: 'Обратная связь',
            url: '',
            modal: 'feedback',
          },
          {
            name: 'Реклама на Всё Своё',
            url: '/promo',
          },
        ],
      },
    ],
  },
];

export const MENU_FOOTER: Array<FooterColumnInterface> = [
  {
    id: 'column2',
    menus: [
      {
        id: 'menu2',
        name: 'Сервисы',
        items: [
          {
            name: 'Журнал',
            url: '/news',
          },
          {
            name: 'Садоводство с нуля',
            url: '/sadovodstvo-s-nulya',
          },
          {
            name: 'Дизайн участка',
            url: '/plans',
          },
          {
            name: 'Карта Дачная',
            url: '/dachnaya',
          },
        ],
      },
    ],
  },
  {
    id: 'column3',
    menus: [
      {
        id: 'menu3',
        name: '',
        items: [
          {
            name: 'Календарь садовода',
            url: '/calendar/seasons',
          },
          {
            name: 'Газификация',
            url: '/gas',
          },
          {
            name: 'Личное подсобное хозяйство',
            url: '/lph',
          },
        ],
      },
    ],
  },
  {
    id: 'column4',
    menus: [
      {
        id: 'menu4',
        name: 'О нас',
        items: [
          {
            name: 'О Россельхозбанке',
            url: 'https://www.rshb.ru/about/',
            external: true,
          },
        ],
      },
      {
        id: 'menu5',
        name: 'По всем вопросам',
        items: [
          {
            name: 'Обратная связь',
            url: '',
            modal: 'feedback',
          },
          {
            name: 'Реклама на Всё Своё',
            url: '/promo',
          },
        ],
      },
    ],
  },
];

export const MENU_FOOTER_POLITICS: Array<FooterColumnMenuItemInterface> = [
  {
    name: 'Политика обработки персональных данных',
    url: AGREEMENT_RSHB_PD_POLICY,
    external: true,
  },
  {
    name: 'Пользовательское соглашение',
    url: AGREEMENT_TERMS,
    external: true,
  },
];

export const MENU_NEWS: Array<NewsLevelInterface> = [
  {
    name: 'Новости',
    icon: 'news',
    url: _url('novosti'),
    children: [],
  },
  {
    name: 'Выбор и покупка участка',
    icon: 'choose',
    children: [
      {
        name: 'Как выбрать участок',
        url: _url('kak-vybrat-uchastok'),
      },
      {
        name: 'Покупка участка и оформление',
        url: _url('pokupka-uchastka-i-oformlenie'),
      },
      {
        name: 'Юридическая проверка участка',
        url: _url('yuridicheskaya-proverka-uchastka'),
      },
    ],
  },
  {
    name: 'Строительство дома',
    icon: 'build',
    children: [
      {
        name: 'Инженерные системы',
        url: _url('inzhenernye-sistemy'),
      },
      {
        name: 'Отделка',
        url: _url('otdelka'),
      },
      {
        name: 'Подготовка участка',
        url: _url('podgotovka-uchastka'),
      },
      {
        name: 'Проектирование',
        url: _url('proektirovanie'),
      },
      {
        name: 'Фундамент и коробка',
        url: _url('fundament-i-korobka'),
      },
      {
        name: 'Бани, гаражи, беседки',
        url: _url('bani-garazhi-besedki'),
      },
    ],
  },
  {
    name: 'Коммуникации',
    icon: 'communications',
    children: [
      {
        name: 'Водоснабжение',
        url: _url('vodosnabzhenie'),
      },
      {
        name: 'Газификация',
        url: _url('gazifikaciya'),
      },
      {
        name: 'Электричество',
        url: _url('elektrichestvo'),
      },
      {
        name: 'Охрана',
        url: _url('oxrana'),
      },
    ],
  },
  {
    name: 'Сад и огород',
    icon: 'garden',
    children: [
      {
        name: 'Все для посадок',
        children: [
          {
            name: 'Болезни и вредители',
            url: _url('bolezni-i-vrediteli'),
          },
          {
            name: 'Новинки селекции',
            url: _url('novinki-selekcii'),
          },
          {
            name: 'Садовый инструмент',
            url: _url('sadovyj-instrument'),
          },
          {
            name: 'Удобрения и стимуляторы',
            url: _url('udobreniya-i-stimulyatory'),
          },
          {
            name: 'Парники и теплицы',
            url: _url('parniki-i-teplicy'),
          },
        ],
      },
      {
        name: 'На грядке',
        url: _url('na-gryadke'),
      },
      {
        name: 'В саду',
        url: _url('v-sadu'),
      },
      {
        name: 'Цветник',
        url: _url('cvetnik'),
      },
      {
        name: 'Комнатные растения',
        url: _url('komnatnyye-rasteniya'),
      },
      {
        name: 'Дизайн участка',
        children: [
          {
            name: 'Озеленение (газон)',
            url: _url('ozelenenie-gazon'),
          },
          {
            name: 'Ландшафт',
            url: _url('landshaft'),
          },
        ],
      },
      {
        name: 'Агрокалькулятор',
        url: _url('agrokalkulyator'),
      },
      {
        name: 'Болезни и симптомы',
        children: [
          {
            name: 'Томат',
            url: _url('tomat'),
          },
          {
            name: 'Огурец',
            url: _url('ogurec'),
          },
          {
            name: 'Перец',
            url: _url('perets'),
          },
        ],
      },
    ],
  },
  {
    name: 'Льготы и предложения',
    icon: 'benefits',
    children: [
      {
        name: 'Поддержка ЛПХ и фермеров',
        url: _url('podderzhka-lph-i-fermerov'),
      },
      {
        name: 'Льготная ипотека',
        url: _url('lgotnaya-ipoteka'),
      },
      {
        name: 'ЖКХ и коммунальные услуги',
        url: _url('zhkh-i-kommunalnye-uslugi'),
      },
      {
        name: 'Поддержка льготников',
        url: _url('podderzhka-lgotnikov'),
      },
      {
        name: 'Земля и жилье от государства',
        url: _url('zemlya-i-zhile-ot-gosudarstva'),
      },
    ],
  },
  {
    name: 'Законы',
    icon: 'laws',
    children: [
      {
        name: 'Земельный участок',
        url: _url('zemelnyy-uchastok'),
      },
      {
        name: 'Дом и постройки',
        url: _url('dom-i-postroyki'),
      },
      {
        name: 'Коммуникации и ресурсы',
        url: _url('kommunikatsii-i-resursy'),
      },
      {
        name: 'Купля-продажа',
        url: _url('kuplya-prodazha'),
      },
      {
        name: 'Прописка и проживание',
        url: _url('propiska-i-prozhivanie'),
      },
      {
        name: 'Наследование и дарение',
        url: _url('nasledovanie-i-darenie'),
      },
      {
        name: 'Жалобы и конфликты с соседями',
        url: _url('zhaloby-i-konflikty-s-sosedyami'),
      },
    ],
  },
  {
    name: 'Налоги и штрафы',
    icon: 'taxes',
    children: [
      {
        name: 'Налог на имущество',
        url: _url('nalog-na-imuschestvo'),
      },
      {
        name: 'Налоговые вычеты',
        url: _url('nalogovye-vychety'),
      },
      {
        name: 'Штрафы и нарушения',
        url: _url('shtrafy-i-narusheniya'),
      },
    ],
  },
  {
    name: 'Мои соседи (СНТ)',
    icon: 'neighbours',
    children: [
      {
        name: 'Организация и управление',
        url: _url('organizaciya-i-upravlenie'),
      },
      {
        name: 'Финансы и бухгалтерия',
        url: _url('finansy-i-buxgalteriya'),
      },
    ],
  },
  {
    name: 'Моё личное хозяйство (ЛПХ)',
    icon: 'benefits',
    children: [
      {
        name: 'Правовой статус',
        url: _url('pravovoj-status'),
      },
      {
        name: 'Планирование ЛПХ',
        url: _url('planirovanie-lpx'),
      },
      {
        name: 'Содержание животных',
        url: _url('soderzhanie-zhivotnyx'),
      },
      {
        name: 'Переработка и хранение продукции',
        url: _url('pererabotka-xranenie-produkcii'),
      },
    ],
  },
  {
    name: 'Полезные мелочи',
    icon: 'useful',
    children: [
      {
        name: 'Дом и быт',
        url: _url('dom-i-byt'),
      },
      {
        name: 'Книги и фильмы',
        url: _url('knigi-i-filmy'),
      },
      {
        name: 'Кулинария',
        url: _url('kulinariya'),
      },
      {
        name: 'Путешествия',
        url: _url('puteshestviya'),
      },
      {
        name: 'Развлечения',
        url: _url('razvlecheniya'),
      },
    ],
  },
  {
    name: 'Видео',
    icon: 'video',
    url: _url('video'),
    children: [],
  },
  {
    name: 'Мастерская',
    icon: 'masterskaya',
    url: '/masterskaya',
    children: [],
  },
];

export const MENU_SERVICES: Array<NewsLevelInterface> = [
  {
    name: 'Лунный календарь',
    icon: 'moon-calendar',
    url: '/calendar/seasons',
    children: [],
  },
  {
    name: 'Планировщик участка',
    icon: 'planner',
    url: '/plans',
    children: [],
    phrases: 'дизайн планировщик планирование план участок проект посадить',
  },
  {
    name: 'Дачные калькуляторы',
    icon: 'calculator',
    children: [
      {
        name: 'Удобрений',
        icon: 'calculator-fertilizers',
        url: '/calculator/agro',
        phrases: 'калькулятор расчет рассчитать удобрение',
      },
      {
        name: 'Полива',
        icon: 'calculator-watering',
        url: '/calculator/watering',
        phrases: 'калькулятор расчет рассчитать вода',
      },
      {
        name: 'Семян',
        icon: 'calculator-seeds',
        url: '/calculator/seeds',
        phrases: 'калькулятор расчет рассчитать семена',
      },
      {
        name: 'Забора',
        icon: 'calculator-fence',
        url: '/calculator/fence',
        phrases: 'калькулятор расчет рассчитать заборы ограждение',
      },
      {
        name: 'Дорожек',
        icon: 'calculator-road',
        url: '/calculator/road',
        phrases: 'калькулятор расчет рассчитать дорожки щебень',
      },
      {
        name: 'Электричества',
        icon: 'calculator-electricity',
        url: '/calculator/electricity',
        phrases: 'калькулятор расчет счетчик э/э электроэнергия',
      },
    ],
  },
  {
    name: 'Справочники',
    icon: 'directory',
    children: [
      {
        name: 'Растений',
        url: '/spravochniki/rasteniya',
      },
      {
        name: 'Комнатных растений',
        url: '/spravochniki/komnatnyh-rasteniy',
      },
      {
        name: 'Болезней растений',
        url: '/spravochniki/bolezni-rastenij',
      },
      {
        name: 'Вредителей',
        url: '/spravochniki/vrediteli',
      },
      {
        name: 'Болезни и симптомы',
        url: '/news/category/tomat',
      },
      {
        name: 'Съедобных грибов',
        url: '/spravochniki/sedobnyh-gribov',
      },
      {
        name: 'Сортов томатов',
        url: '/tomatoes',
      },
    ],
  },
  {
    name: 'Питомники растений',
    icon: 'nurseries',
    url: '/spravochniki/pitomniki',
    children: [],
  },
  {
    name: 'Умные определители',
    icon: 'ai-diagnose',
    children: [
      {
        name: 'Болезней растений',
        url: '/opredelit-bolezn-rasteniya-po-foto',
        phrases:
          'умны определител распозна желтеют сохнут гниют скручиваются вянут чернеют опадают скручиваются пятна листьях стеблях вредители паутина налет тля мошки корни',
      },
      {
        name: 'Грибов',
        url: '/opredelit-grib-po-foto',
        phrases: 'умны определител распозна',
      },
    ],
  },
];

function _url(slug: string): string {
  return `/news/category/${slug}`;
}
